import React from 'react';
import { cn } from '@/utils';

interface ErrorLabelProps {
  message?: string;
  disabled?: boolean;
  className?: string;
}

const ErrorLabel: React.FC<ErrorLabelProps> = ({ message = '', disabled, className }) => {
  return (
    <p className={cn(`text-other-red body-sm font-normal ${disabled ? 'text-gray-600' : ''}`, className)}>{message}</p>
  );
};

export default ErrorLabel;
